
// eslint-disable-next-line import/prefer-default-export
export function isGenderFemaleOrGirl(gendercode) {
  if (gendercode && (gendercode === "F" || gendercode === "G")) {
    return true;
  }
  return false;
}


